import { UseLoadingReturn } from "@/hooks/use-loading";
import useRemove from "@/hooks/use-remove";
import contactService from "@/services/contact.service";
import { RemoveByIdProps } from "@/types/requests.types";

export type UseRemoveAddressReturn = {
  remove: (props: RemoveByIdProps) => Promise<void>;
} & UseLoadingReturn;

const useRemoveAddress = (): UseRemoveAddressReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, remove } = useRemove({
    operation: (addressId) => contactService.deleteAddress(addressId),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    remove,
  };
};

export default useRemoveAddress;
